<template>
  <a-card :bordered="false">
    <!--      <a-row style="position: absolute;top: -70px; width: calc(100% - 70px);" type="flex" justify="space-between" align="bottom">-->
    <!--        <a-col :span="12"></a-col>-->
    <!--        <a-col :span="12">-->
    <!--          <a-row type="flex" justify="center" style="box-sizing: border-box;">-->

    <!--            <a-col :span="7">-->
    <!--            </a-col>-->
    <!--            <a-col :span="6">-->
    <!--              <a-button  type="primary" @click="ExportTeam()">导出Excel</a-button>-->
    <!--            </a-col>-->
    <!--          </a-row>-->
    <!--        </a-col>-->
    <!--      </a-row>-->
    <!--    <a-col :span="6">-->
    <!--      <button  type="primary"  @click="export()">导出EXCEL</button>-->
    <!--    </a-col>-->

    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="仓库名称">
              <a-input v-model="queryParam.storeName" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="仓库类型">
              <a-select v-model="queryParam.storeType" allowClear="true">
                <a-select-option value="0">主库</a-select-option>
                <a-select-option value="1">机构分库</a-select-option>
                <a-select-option value="2">师傅分库</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="配件类型">
              <a-select v-model="queryParam.accessoryType" :allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="type in dataType" :title="type.accessoryType" :key="type.accessoryType">{{
                type.accessoryType
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="配件名称">
              <a-select v-model="queryParam.accessoryName" :allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="type in dataName" :title="type.accessoryName" :key="type.accessoryName">{{
                type.accessoryName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="配件型号">
              <a-select v-model="queryParam.accessoryCategory" :allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="type in dataCategory" :title="type.accessoryCategory"
                  :key="type.accessoryCategory">{{ type.accessoryCategory }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="配件规格">
              <a-select v-model="queryParam.accessorySpecification" :allowClear="true" showSearch
                optionFilterProp="children" :filterOption="filterOption">
                <a-select-option v-for="type in dataSpecification" :title="type.accessorySpecification"
                  :key="type.accessorySpecification">{{ type.accessorySpecification }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="入库人" style="margin-left: 14px">
              <a-input v-model="queryParam.createBy" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="预警值" style="margin-left: 14px">
              <a-input v-model="queryParam.warningNumber" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="产品类别">
              <a-select v-model="queryParam.installType" allowClear="true">
                <a-select-option v-for="type in restaurantTypes2" :title="type.label" v-bind:value="type.code">{{
                type.label
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col style="float: right; margin-right: 14px">
            <a-button type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)">查询</a-button>
            <a-button style="margin-right: 8px" @click="() => (queryParam = {})">清空</a-button>
            <a-button type="primary" @click="ExportTeam()">导出Excel</a-button>
          </a-col>

          <!--          <span class="table-page-search-submitButtons">-->
          <!--               <a-row type="flex" justify="space-between">-->
          <!--            <a-col :span="6" style="text-align: right">-->
          <!--              <a-button type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)">查询</a-button>-->
          <!--              <a-button   @click="() => queryParam = {}">清空</a-button>-->
          <!--            </a-col>-->
          <!--               </a-row>-->
          <!--            </span>-->
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-divider />
      <a-row type="flex" justify="space-between">
        <a-col :span="16"></a-col>
        <a-col :span="4" style="text-align: right">
          <a-button style="margin-right: 8px" value="0" v-if="addEnable" type="primary" icon="plus"
            @click="$refs.modal.add()">入库</a-button>
        </a-col>
        <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
          <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
        </a-dropdown>
      </a-row>
    </div>

    <!--     <div class="table-operator">-->
    <!--      <a-button  type="primary" icon="plus" @click="$refs.modal.add()">入库</a-button>-->
    <!--      <a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
    <!--        <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>-->
    <!--      </a-dropdown>-->
    <!--    </div>-->
    <s-table size="default" ref="table" rowKey="storageAccessoryId" :columns="columns" :data="loadData"
      :scroll="{ x: '1600px' }" bordered>
      <span slot="storeType" slot-scope="text, record">
        <a-text v-if="record.storeType == 0">主库 </a-text>
        <a-text v-else-if="record.storeType == 1">机构分库</a-text>
        <a-text v-else="record.storeType == 2">师傅分库</a-text>
      </span>
      <span slot="action2" slot-scope="text, record">
        <span :class="[text < record.warningNumber ? 'ColorFont' : '']">{{ text }}</span>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-divider v-if="detailsEnabel" type="vertical" />
        <a v-if="detailsEnabel" @click="delByIds(record.storageAccessoryId)">详情</a>
        <a-divider v-if="outtoStorageEnable" type="vertical" />
        <a v-if="outtoStorageEnable" @click="detailBtn(record)">出库</a>
        <a-divider v-if="editEnabel" type="vertical" />
        <a @click="delById(record)" v-if="record.forbiddenStatus == 1 && editEnabel">启用</a>
        <a @click="delById(record)" v-if="record.forbiddenStatus == 0 && editEnabel">禁用</a>
        <!--        <a v-if="removeEnable" @click="delById(record.)">禁用</a>-->
        <a-divider v-if="detailsEnabel" type="vertical" />
        <a v-if="detailsEnabel" @click="deleteId(record)">删除</a>
      </span>
    </s-table>

    <a-modal title="详情" style="top: 20px" :width="1000" v-model="dateModel" :confirmLoading="confirmLoading"
      @ok="handleSubmit">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仓库名称">
        <a-input v-model="boxLis2.storeName" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
        <a-input v-model="boxLis2.accessoryName" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仓库类型">
        <a-input v-model="boxLis2.storeTypeName" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库数量">
        <a-input v-model="boxLis2.totalAccessoryNumber" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="库存剩余数量">
        <a-input v-model="boxLis2.accessoryNumber" disabled="disabled" />
      </a-form-item>
      <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件数量">
        <a-input v-model="boxLis2.privateNumber" disabled="disabled" />
      </a-form-item> -->

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="锁安入库单价">
        <a-input v-model="boxLis2.unityPrice" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅配件单价">
        <a-input v-model="boxLis2.masterUnityPrice" disabled="disabled" />
      </a-form-item>
      <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业配件总价">
        <a-input v-model="boxLis2.totalPrice" disabled="disabled" />
      </a-form-item> -->
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="警戒值">
        <a-input v-model="boxLis2.warningNumber" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
        <a-input v-model="boxLis2.remark" disabled="disabled" />
      </a-form-item>
    </a-modal>

    <a-modal title="出库" style="top: 20px" :width="1000" v-model="dateModel2" :confirmLoading="confirmLoading"
      @ok="handleSubmit2">
    </a-modal>

    <storageAccessory-modal ref="modal" @ok="handleOk" />
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  storageExport,
  selectaccessory,
  selectenterprise,
  getStorageAccessoryList,
  delStorageAccessory,
  forbiddenaccessorystorage,
  saveStorageAccessory,
  getoneaccessorystorage
} from '@/api/accessory/storageAccessory'
import {
  selectAccessorySpecification,
  selectAccessoryCategory,
  selectAccessoryName,
  selectAccessoryType
} from '@/api/accessory/supplier'

import StorageAccessoryModal from './modules/StorageAccessoryModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'TableList',
  components: {
    STable,
    StorageAccessoryModal
  },
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      // 配件规格列表
      dataSpecification: '',
      // 配件型号列表
      dataCategory: '',
      // 配件名称列表
      dataName: '',
      // 配件类型列表
      dataType: '',

      accessoryName: '',
      accessoryId: '',
      boxLis2: '',
      boxLis3: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      dateModel: false,
      boxLis: '',

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',

          scopedSlots: { customRender: 'action' }
        },
        {
          title: '配件类型',
          dataIndex: 'accessories[0].accessoryType',
          align: 'center'
        },
        {
          title: '配件名称',
          dataIndex: 'accessories[0].accessoryName',
          align: 'center'
        },
        {
          title: '配件规格',
          dataIndex: 'accessories[0].accessorySpecification',
          align: 'center'
        },
        {
          title: '配件型号',
          dataIndex: 'accessories[0].accessoryCategory',
          align: 'center'
        },
        {
          title: '产品类别',
          dataIndex: 'accessories[0].installType',
          align: 'center'
        },
        {
          title: '仓库名称',
          dataIndex: 'storeName',
          align: 'center'
        },
        {
          title: '仓库类型',
          dataIndex: 'storeType',
          align: 'center',
          scopedSlots: { customRender: 'storeType' }
        },
        {
          title: '锁安入库单价',
          dataIndex: 'unityPrice',
          align: 'center'
        },
        {
          title: '师傅配件单价',
          dataIndex: 'masterUnityPrice',
          align: 'center'
        },
        {
          title: '入库数量',
          dataIndex: 'totalAccessoryNumber',
          align: 'center',
          scopedSlots: { customRender: 'action2' }
        },
        {
          title: '库存剩余数量',
          dataIndex: 'accessoryNumber',
          align: 'center',
          scopedSlots: { customRender: 'action2' }
        },
        {
          title: '预警值',
          dataIndex: 'warningNumber',
          align: 'center'
        },
        {
          title: '入库人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '入库时间',
          dataIndex: 'createTime',
          align: 'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getStorageAccessoryList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      restaurantTypes2: [],
      selectedRows: [],
      addEnable: checkPermission('storageAccessorywarehousing'),
      editEnabel: checkPermission('storageAccessoryEnable'),
      outtoStorageEnable: checkPermission('storageAccessoryoutbound'),
      detailsEnabel: checkPermission('storageAccessoryinfo')
    }
  },
  filters: {},
  async created() {
    // 配件规格
    selectAccessorySpecification().then(res => {
      console.log(res)
      this.dataSpecification = res.rows
    })

    // 配件型号
    selectAccessoryCategory().then(res => {
      console.log(res)
      this.dataCategory = res.rows
    })

    // 配件名称
    selectAccessoryName().then(res => {
      console.log(res)
      this.dataName = res.rows
    })

    // 配件类型
    selectAccessoryType().then(res => {
      console.log(res)
      this.dataType = res.rows
    })

    this.restaurantTypes2 = []
    this.restaurantOperTypeMap2 = await getDictMap('install_type')
    this.restaurantOperTypeMap2.forEach((value, key) => {
      this.restaurantTypes2.push({ code: key, label: value })
    })
    selectaccessory().then(res => {
      console.log(res)
      this.boxLis3 = res.rows
      console.log(this.boxLis)
    })
  },
  methods: {
    // 企业搜索功能
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    // 删除
    deleteId(record) {
      let that = this
      var forbiddenStatus = record.forbiddenStatus
      if (record.forbiddenStatus == '0') {
        var forbiddenStatus = '1'
      } else {
        var forbiddenStatus = '0'
      }
      if (forbiddenStatus == 0) {
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            delStorageAccessory({ storageAccessoryId: record.storageAccessoryId }).then(res => {
              console.log(res)
              if (res.code == 0) {
                that.$message.success('删除成功')
                that.handleOk()
              } else {
                that.$message.error('存在使用记录删除失败')
              }
            })
          },
          onCancel() {
            console.log('Cancel')
          }
        })
      } else {
        this.$message.success('请先禁用')
      }
    },

    ExportTeam() {
      var str = process.env.VUE_APP_API_BASE_URL + '/stock/storageAccessory/storageExport?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
      // storageExport(this.queryParam).then(res => {
      //   console.log(res)
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = '库存管理'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },

    // 获取配件Id
    onchange2(values) {
      console.log(values)
      this.accessoryId = values
      let boxLis = this.boxLis
      for (let i = 0; i < boxLis.length; i++) {
        if (boxLis[i].accessoryId == values) {
          this.accessoryId = boxLis[i].accessoryId
          this.accessoryName = boxLis[i].accessoryName
        }
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleOk() {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },

    detailBtn(record) {
      console.log('aaaa')
      this.$refs.modal.edit2(record)
    },
    delByIds(ids) {
      this.dateModel = true
      getoneaccessorystorage({ storageAccessoryId: ids }).then(res => {
        console.log('aaaaaaaaaaaaaaaa')
        console.log(res)
        var boxLis = res
        if (boxLis.storeType == 0) {
          boxLis.storeTypeName = '主库'
        } else if (boxLis.storeType == 1) {
          boxLis.storeTypeName = '机构分库'
        } else {
          boxLis.storeTypeName = '师傅分库'
        }
        this.boxLis2 = boxLis
        console.log(this.boxLis2)
      })
    },
    handleSubmit() {
      this.dateModel = false
    },

    delById(record) {
      var forbiddenStatus = record.forbiddenStatus

      if (record.forbiddenStatus == '0') {
        var forbiddenStatus = '1'
      } else {
        var forbiddenStatus = '0'
      }
      var storageAccessoryId = record.storageAccessoryId
      if (forbiddenStatus == 0) {
        forbiddenaccessorystorage({ storageAccessoryId: storageAccessoryId, forbiddenStatus: forbiddenStatus }).then(
          res => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('启用成功')
              // this.handleOk()
              record.forbiddenStatus == '1'
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
            this.selectedRowKeys = []
          }
        )
      } else {
        forbiddenaccessorystorage({ storageAccessoryId: storageAccessoryId, forbiddenStatus: forbiddenStatus }).then(
          res => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              record.forbiddenStatus == '0'
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
            this.selectedRowKeys = []
          }
        )
      }
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
.ColorFont {
  color: red;
}
</style>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
